import { Button } from "@material-ui/core";
import React from "react";
import { Route } from "react-router-dom";
import CloseMenuIcon from "../../../resources/wrappers/menu/CloseMenuIcon";
import { GoogleTagManagerService } from "../../../services/analitycs/GoogleTagManagerService";
import './MobileInfoAddProduct.css';

export class MobileInfoAddProduct extends React.Component<any, any> {

    componentDidMount(){
        GoogleTagManagerService.getInstance().pushInteractionEvent('popupImpression', 'Popup', 'impression', 'catalogo prodotti: creazione prodotto: inserimento prodotto manuale');
        window.scrollTo(0, 0);
    }
    
    private goToNextStep(history: any){
        history.push('/addProduct/insertOrUpdate');
    }

    private closeInfoMessage(history: any){
        history.goBack();
    }

    render(){
        return <div className={"main-container-mobile-info-add-product"}>
            <div className={"main-container-mobile-info-add-product-container"}>
                <div className={"main-container-mobile-info-add-product-head"}>
                    <div className={"mobile-info-add-product-title-container"}>
                        <p className={"mobile-info-add-product-head-title"}>{"Crea Prodotto".toUpperCase()}</p>
                    </div>
                    <Route render={({history}) => {
                        return <div className={"mobile-info-add-product-icon-container"} onClick={() => this.closeInfoMessage(history)}>
                            <CloseMenuIcon width={'16px'} height={'16px'} fill={'#FFFFFF'} />
                        </div>
                    }} />
                </div>
                <div className={"mobile-info-add-main-title-container"}>
                    <p className={"mobile-info-add-main-title"}>Stai inserendo i<br/> prodotti manualmente!</p>
                </div>
                <div className={"mobile-info-add-subtitle-container"}>
                    <p className={"mobile-info-add-subtitle"}>Da desktop hai a disposizione la funzionalità<br/>di importazione massiva dei prodotti nel tuo<br/>catalogo tramite file excel.</p>
                </div>
                <div className={"mobile-info-add-button-next-container"}>
                    <Route render={({history}) => {
                        return <Button id={"mobile-info-add-product-button-next"} onClick={() => {
                            this.goToNextStep(history);
                        }}>AVANTI</Button>;
                    }}/>
                </div>
            </div>
        </div>
    }
}